import { render } from "./Switch.vue?vue&type=template&id=4fc8db87"
import script from "./Switch.vue?vue&type=script&lang=ts"
export * from "./Switch.vue?vue&type=script&lang=ts"

import "./Switch.vue?vue&type=style&index=0&id=4fc8db87&lang=css"
script.render = render

export default script